<ng-container *ngIf="(dashboardDatas$ | async) as dashboardDatas">

  <div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">

    <!-- CENTER -->
    <div class="center">

      <!-- HEADER -->
      <div class="header accent p-24 pb-0" fxLayout="column" fxLayoutAlign="space-between">

        <div fxLayout="row" fxLayoutAlign="space-between start">
          <span class="mat-display-1 my-0 my-sm-24 welcome-message" [@animate]="{value:'*',params:{x:'50px'}}">TANGO Cards Dashboard</span>
        </div>

        <div fxLayout="row">
          <div class="selected-project">{{dashboardDatas.data.dashboard?.accountInfo?.displayName}} ({{dashboardDatas.data.dashboard?.accountInfo?.accountIdentifier}})</div>
        </div>
      </div>
      <!-- / HEADER -->

      <!-- CONTENT -->
      <div class="content h-100-p">

        <mat-tab-group class="h-100-p">

          <mat-tab label="Send Cards">
            <ng-template matTabContent>
              <app-send-cards></app-send-cards>
            </ng-template>
          </mat-tab>

          <mat-tab label="Transactions History">
            <ng-template matTabContent>
              <div class="grid-container">

                <dx-data-grid
                  #historyGrid
                  *ngIf="dashboardDatas.data?.dashboard?.orderHistory?.orders?.length > 0"
                  id="orderHistory"
                  keyExpr="referenceOrderID"

                  [hoverStateEnabled]="true"

                  [dataSource]="dashboardDatas.data?.dashboard?.orderHistory?.orders"
                  [height]="'100%'"

                  [columns]="orderHistoryColumns"

                  [columnAutoWidth]="true"

                  [allowColumnReordering]="true"
                  [allowColumnResizing]="true"

                  [showColumnLines]="false"
                  [showRowLines]="false"
                  [showBorders]="true"
                  [rowAlternationEnabled]="false"

                >

                  <dxo-selection mode="single"></dxo-selection>
                  <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>
                  <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                  <dxo-group-panel [visible]="false"></dxo-group-panel>

                  <dxo-export [enabled]="true" [fileName]="'Tango Order Histories'"></dxo-export>
                  <dxo-scrolling mode="virtual" useNative="true" showScrollbar="always"></dxo-scrolling>

                  <div *dxTemplate="let d of 'referenceOrderIDTemplate'">
                    <button [disabled]="(tangoCardsService.isResending$|async)?.[d.data.referenceOrderID]" mat-stroked-button (click)="resendOrder(d.data.referenceOrderID)">
                      <mat-icon>mail</mat-icon>
                      {{d.data.referenceOrderID}}
                    </button>
                  </div>

                </dx-data-grid>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Short Term">
            <ng-template matTabContent>
              <div class="grid-container">
                <dx-data-grid
                  *ngIf="dashboardDatas.data?.dashboard?.shortTermAmountDetail?.length > 0"

                  id="shortTermList"
                  [dataSource]="dashboardDatas.data?.dashboard?.shortTermAmountDetail"
                  [height]="'100%'"
                >
                  <dxo-export [enabled]="true" [fileName]="'Tango ShortTermAmountDetail'"></dxo-export>
                  <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>
                  <dxo-scrolling mode="virtual" useNative="true" showScrollbar="always"></dxo-scrolling>
                </dx-data-grid>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab label="Search..." class="h-100-p">
            <ng-template matTabContent>
              <app-search-cards></app-search-cards>
            </ng-template>
          </mat-tab>

          <mat-tab *appIfUserHas="['GOD_MODE']" label="Debug" class="h-100-p">
            <ng-template matTabContent>
              <div class="h-100-p" style="height: calc(100vh - 200px);">
                <app-json-editor [readOnly]="true" [autoExpand]="false" [content]="dashboardDatas"></app-json-editor>
              </div>
            </ng-template>
          </mat-tab>

        </mat-tab-group>

      </div>

    </div>

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="project-dashboard-right-sidebar-1" position="right" lockedOpen="gt-md">

      <!-- SIDEBAR CONTENT -->
      <div class="content">

        <!-- WIDGET GROUP -->
        <div class="widget-group" fxLayout="column" fxFlex="100" [@animateStagger]="{value:'50'}">

          <!-- NOW WIDGET -->
          <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="pb-0">

            <!-- Front -->
            <div *appLoadingUntil="!(tangoBalanceService.uxInterations|async).refreshBalance" class="fuse-widget-front">

              <div class="pl-16 pr-8 py-16" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="h3">{{(tangoBalanceService.accountInfo|async)?.accountIdentifier}}</div>

                <div>
                  <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="more">
                    <mat-icon>more_vert</mat-icon>
                  </button>

                  <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item aria-label="Flip widget" (click)="displayRefundPopup()">
                      Refund
                    </button>
                  </mat-menu>
                </div>

              </div>

              <!--              <div class="p-16 pb-24" fxLayout="column" fxLayoutAlign="center center">-->
              <!--                <div class="h1 secondary-text">-->
              <!--                  <span>Balance</span>-->
              <!--                </div>-->
              <!--                <div class="font-size-48 line-height-88 secondary-text font-weight-400">{{ (dashboardDatas.data?.dashboard?.accountInfo?.currentBalance || '?')}}</div>-->
              <!--                <div class="h1 secondary-text"><span>{{dashboardDatas.data?.dashboard?.accountInfo?.currencyCode}}</span></div>-->
              <!--              </div>-->

              <div class="p-16 pb-24" fxLayout="column" fxLayoutAlign="center center">
                <div class="h1 secondary-text">
                  <span>Balance (v2)</span>
                </div>
                <div class="font-size-48 line-height-88 secondary-text font-weight-400">
                  {{(tangoBalanceService.accountInfo|async)?.currentBalance}}
                </div>
                <div class="h1 secondary-text"><span>{{(tangoBalanceService.accountInfo|async)?.currencyCode}}</span></div>
              </div>


            </div>
            <!-- / Front -->

          </fuse-widget>
          <!-- / NOW WIDGET -->

          <!-- NOW WIDGET -->
          <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="pb-0">

            <!-- Front -->
            <div class="fuse-widget-front">

              <div class="pl-16 pr-8 py-16" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="h3">(Inbe)</div>
              </div>

              <div class="p-16 pb-24" fxLayout="column" fxLayoutAlign="center center">
                <div class="h1 secondary-text">
                  <span>Amount due</span>
                </div>
                <div class="font-size-48 line-height-88 secondary-text font-weight-400">{{dashboardDatas.data?.dashboard?.amountDue}}</div>
                <div class="h1 secondary-text"><span>{{dashboardDatas.data?.dashboard?.accountInfo?.currencyCode}}</span></div>
              </div>

            </div>
            <!-- / Front -->

          </fuse-widget>
          <!-- / NOW WIDGET -->

        </div>
        <!-- / WIDGET GROUP -->

      </div>
      <!-- / SIDEBAR CONTENT -->

    </fuse-sidebar>

  </div>

  <dx-popup
    *ngIf="displayRefund"

    [width]="'50%'"
    [height]="'50%'"

    [showTitle]="true"
    [title]="'Refund Tango account'"

    [dragEnabled]="true"
    [resizeEnabled]="true"

    [closeOnOutsideClick]="true"
    [showCloseButton]="true"

    (onHiding)="displayRefund = false"
    [visible]="true"

  >
    <div *dxTemplate="let data of 'content'">

      <div
        *ngIf="(tangoBalanceService.creditCards|async) as credicCards"
        fxFlex="grow" fxLayout="column" style="overflow-y: hidden">

        <div fxFlex="grow" fxLayout="column" style="overflow-y: hidden">

          <ng-container *ngIf="refundMode">

            <div *appLoadingUntil="credicCards.length>0" fxLayout="column" class="p-8">

              <div fxLayout="row">

                <div fxFlex="50">
                  <h4>{{'Choisir une carte'|translate}}</h4>
                  <mat-radio-group
                    fxLayout="column"
                    [formControl]="fRefund.get('creditCardToken')"
                  >
                    <mat-radio-button
                      fxFlex
                      class="mb-4"
                      *ngFor="let aCard of credicCards"
                      [value]="aCard.token"
                    >
                      {{aCard.label}} - (#### #### #### {{aCard.lastFourDigits}})
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
                <div fxFlex fxLayout fxLayoutAlign="end center" class="ml-16">
                  <mat-form-field class="w-40-p mt-8">
                    <mat-label>{{'Montant' | translate}}</mat-label>
                    <input matInput type="text" [formControl]="fRefund.get('amount')">
                    <mat-hint>USD</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <mat-divider class="mt-8 mb-8"></mat-divider>

              <div fxFlex="row">
                <div fxFlex>
                  <button
                    [disabled]="fRefund.get('creditCardToken').invalid"
                    mat-button
                    (click)="creditCardUnregisters(fRefund.get('creditCardToken').value)"
                    class="mr-16"
                  >
                    <mat-icon>delete</mat-icon>
                    Delete card...
                  </button>
                  <button mat-button (click)="switchRefundMode()">
                    New Card
                  </button>
                </div>
                <div fxFlex fxLayoutAlign="end center">
                  <button
                    [disabled]="fRefund.invalid"
                    mat-stroked-button
                    (click)="creditCardDeposits()">
                    <mat-icon>currency_exchange</mat-icon>
                    Refund!
                  </button>
                </div>
              </div>

              <div
                fxFlex="grow"
                *ngIf="(tangoBalanceService.uxInterations|async)?.foundCardMessage"
                class="mt-8"
              >
                <app-json-editor
                  [content]="(tangoBalanceService.uxInterations|async).foundCardMessage"
                  [readOnly]="true">
                </app-json-editor>
              </div>



            </div>

          </ng-container>

          <ng-container *ngIf="!refundMode">

            <div fxLayout="column">

              <div fxFlex fxLayout="column">

                <mat-form-field class="w-50-p pr-4">
                  <mat-label>{{'Libellé' | translate}}</mat-label>
                  <input matInput type="text" [formControl]="fNewCard.get('label')">
                </mat-form-field>
                <div fxLayout>
                  <mat-form-field class="w-50-p pr-4">
                    <mat-label>{{'Numéro' | translate}}</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['creditCard', 'number'])">
                  </mat-form-field>
                  <mat-form-field class="w-20-p pr-4">
                    <mat-label>{{'Expiration' | translate}}</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['creditCard', 'expiration'])">
                    <mat-hint>Format: YYYY-MM</mat-hint>
                  </mat-form-field>
                  <mat-form-field class="w-10-p pr-4">
                    <mat-label>{{'VerificationNumber' | translate}}</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['creditCard', 'verificationNumber'])">
                    <mat-hint>Format: 3 or 4 digits</mat-hint>
                  </mat-form-field>
                </div>

              </div>

              <div fxFlex fxLayout="column">

                <div fxLayout="row">
                  <mat-form-field class="w-30-p pr-4">
                    <mat-label>firstName</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'firstName'])">
                  </mat-form-field>
                  <mat-form-field class="w-70-p pr-4">
                    <mat-label>lastName</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'lastName'])">
                  </mat-form-field>
                </div>
                <div fxLayout="column">
                  <mat-form-field class="w-100-p pr-4">
                    <mat-label>addressLine1</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'addressLine1'])">
                  </mat-form-field>
                  <mat-form-field class="w-100-p pr-4">
                    <mat-label>addressLine2</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'addressLine2'])">
                  </mat-form-field>
                </div>
                <div fxLayout>
                  <mat-form-field class="w-30-p pr-4">
                    <mat-label>city</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'city'])">
                  </mat-form-field>
                  <mat-form-field class="w-20-p pr-4">
                    <mat-label>state</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'state'])">
                  </mat-form-field>
                  <mat-form-field class="w-20-p pr-4">
                    <mat-label>postalCode</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'postalCode'])">
                  </mat-form-field>
                  <mat-form-field class="w-30-p pr-4">
                    <mat-label>country</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'country'])">
                  </mat-form-field>
                </div>

                <div fxLayout>
                  <mat-form-field class="w-30-p pr-4">
                    <mat-label>emailAddress</mat-label>
                    <input matInput type="text" [formControl]="fNewCard.get(['billingAddress', 'emailAddress'])">
                  </mat-form-field>
                </div>

              </div>

            </div>

            <div fxFlex fxLayoutAlign="end center">
              <button mat-button (click)="refundMode=true">Cancel</button>
              <button [disabled]="fNewCard.invalid" mat-button (click)="addCard()">Add Card</button>
            </div>

          </ng-container>

        </div>
      </div>
    </div>

  </dx-popup>

</ng-container>
